import { render, staticRenderFns } from "./BirdDogItemInfo.vue?vue&type=template&id=8b3d5486&scoped=true&"
import script from "./BirdDogItemInfo.vue?vue&type=script&lang=js&"
export * from "./BirdDogItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./BirdDogItemInfo.vue?vue&type=style&index=0&id=8b3d5486&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3d5486",
  null
  
)

export default component.exports